import React from 'react';
import SectionLoading from "../../common/SectionLoading";
import ErrorMsg from "../home/ErrorMsg";
import SuccessMsg from "../home/SuccessMsg";
import { Icon, Typography } from "../../ecosystem";

const RemoveMsg = ({
    removeAction,
    removingConfirmed
}) => {

    return (
        <div className='col-12 text-sm-center'>
            {removeAction.waiting ? (
                <SectionLoading />
            ) : (
                removingConfirmed &&
                    (removeAction.error
                        ? (
                            <ErrorMsg
                                message={
                                    typeof removeAction.error === 'string'
                                        ? removeAction.error
                                        : `Sorry, we're unable to remove ${removingConfirmed.displayName}.`
                                }
                            />
                        ) : (
                        <SuccessMsg
                            message={`${ removingConfirmed.displayName } successfuly removed!`}
                        />
                    ))
            )}
        </div>
    );
}

export default RemoveMsg;
